export const queryKeys = {
  DEPARTMENTS: 'departments'
};
